import { Outlet } from "react-router";
import Header from "../../../component/layout/header";
import useNav from "../../../script/tabingNavArray";

const LeadsLayout = () => {
  const navList = useNav();
  let { LeadsBottomHeader, LeadsTopHeader } = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={LeadsBottomHeader} topTabs={LeadsTopHeader} />
      <Outlet />
    </div>
  );
};

export default LeadsLayout;
